import React from 'react';

type Props = {
    message   : string
    close     : callback
    fadeTime  : number
}

export default function Growl_SuccessMessage(props:Props) {

    const classes   = Classes("ui5-pale-bg notification green", "h-100-percent")

    const style     = {
        transition: "opacity " + props.fadeTime + "s"
    }

    return (
        <div className={Classes(classes)} style={style}>
            <div className="flex-row-left-center">
                <div className="left-indicator" />
                <div className="i5-done ui5-color-green fs-15 m-l-3"/>
                <div className="ui5-txt-less-important max-w-200 m-l-10">
                    {props.message}
                </div>
            </div>
            <div className="close i5-delete" onClick={props.close}/>
        </div>
    )

}
